.codes-container{background-color:#f9f9f9;border:1px solid #dadada;border-radius:8px;margin:3em auto;padding:8px}
/*# sourceMappingURL=mfa-recovery-codes.component-AS6X2LUQ.css.map */
